import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const NotFound = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();

  return (
    <>
      <div className='min-h-full'>
        <main>
          <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-base leading-7 text-gray-dark sm:text-xl '>
                  Welcome Back, {state?.user?.firstName}
                </h2>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0 grid justify-items-center'>
              <img
                src='/assets/images/404.svg'
                className='w-64'
                alt='404_error_image'
              />
              <h2 className='mt-10 text-center text-base font-base leading-0 text-gray-dark sm:text-xl '>
                You might have taken wrong path! No page found
              </h2>
              <button
                onClick={(e) => {
                  navigate(-1);
                }}
                className='inline-flex mt-5 justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                Back
              </button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default NotFound;
